/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FilePDFIcon = ({ width = 24, height = 24, hidden = false, title = 'File PD F' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M20 2v10h10L20 2z" />
    <path
      d="M16.307 17.031c0-.763-.237-1.13-.713-1.13a.521.521 0 0 0-.5.317l-.021.05c-.382.655-.094 2.39.677 4.306a25.062 25.062 0 0 0 .557-3.543Zm2.254 8.633.021-.007h-.016c-.007.005-.006.006-.005.007ZM8.416 30.718a.628.628 0 0 0 .216.612.616.616 0 0 0 .432.158c.828 0 2.153-1.411 3.5-3.722-2.42 1.008-3.99 2.124-4.148 2.952Zm7.625-8.266c-.26.778-.454 1.541-.756 2.29-.26.626-.584 1.318-.958 2.031.641-.216 1.462-.526 2.152-.713.775-.206 1.376-.273 2.078-.4a14.16 14.16 0 0 1-1.61-1.8 16.617 16.617 0 0 1-.906-1.407Zm6.9 3.3a10.2 10.2 0 0 0-3.521.122 6.493 6.493 0 0 0 2.837 1.6 1.686 1.686 0 0 0 .446.058 1.009 1.009 0 0 0 1.088-.713c.109-.565-.233-.939-.853-1.069ZM19 14a1 1 0 0 1-1-1V2H7a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V14Zm5.875 12.866a1.022 1.022 0 0 1-.064.353 1.61 1.61 0 0 1-1.57 1.008 7.111 7.111 0 0 1-4.392-2.182c-.777.137-1.5.267-2.369.5-.8.209-1.691.525-2.434.785C12.722 29.718 10.972 32 9.388 32a1.236 1.236 0 0 1-1.029-.389 1.305 1.305 0 0 1-.346-1.044c.209-1.2 2.073-2.383 4.838-3.485a25.1 25.1 0 0 0 1.349-2.635c.483-1.174.784-2.117 1.123-3.139-.973-2.146-1.282-4.392-.742-5.321a1.207 1.207 0 0 1 .986-.663c1.274-.043 1.649 1.562 1.649 2.426a14.064 14.064 0 0 1-.879 4.075 20.321 20.321 0 0 0 1.138 1.9 11.175 11.175 0 0 0 1.647 1.775 15.28 15.28 0 0 1 2.578-.245 4.019 4.019 0 0 1 2.908.878 1.1 1.1 0 0 1 .267.72Z"
    />
  </svg>`;
};
